var map = {
	"./achievements.js": 73232,
	"./airdrop.js": 28913,
	"./appcenter.js": 25282,
	"./assets.js": 91407,
	"./autobot.js": 54855,
	"./bioMatrixScan.js": 64335,
	"./daily.js": 51572,
	"./deposit.js": 22881,
	"./lottery.js": 43136,
	"./lucky.js": 30457,
	"./luckybox.js": 54573,
	"./mine.js": 40821,
	"./ranking.js": 51734,
	"./squad.js": 20849,
	"./task.js": 72390,
	"./user.js": 69220,
	"./wallet.js": 9944
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 80095;